import React from 'react';
import { Box } from '../CommonComponents/OPL/Box/Box';
import { Text } from '../CommonComponents/OPL/Text/Text';
import { useSelector } from 'react-redux';
import {
  selectDisplayBehavioralFinanceSection,
  selectHasAssetBucketing,
  selectHasBeFi20Dashboard,
  selectHasPulseCheckDashboard,
  selectHasRtq,
} from '../CommonSelectors/CommonAreaSelector';
import { Wrapper } from './BeFi.styles';
import { PLDCard } from '../FinancialPlanOPL/GoalsSummary/components/HighlightGoals/components/PLDCard/PLDCard';
import { BeFi20Card } from '../FinancialPlanOPL/GoalsSummary/components/HighlightGoals/components/BeFi20Card/BeFi20Card';
import { PulseCheckCard } from '../FinancialPlanOPL/GoalsSummary/components/HighlightGoals/components/PulseCheckCard/PulseCheckCard';
import { RiskToleranceCard } from '../FinancialPlanOPL/GoalsSummary/components/HighlightGoals/components/RiskTolerance/RiskToleranceCard';

export const BeFi = () => {
  const DisplayBehavioralFinanceSection = useSelector(selectDisplayBehavioralFinanceSection);
  const HasAssetBucketing = useSelector(selectHasAssetBucketing);
  const HasRtq = useSelector(selectHasRtq);
  const HasBeFi20 = useSelector(selectHasBeFi20Dashboard);
  const HasPulseCheck = useSelector(selectHasPulseCheckDashboard);

  if (!DisplayBehavioralFinanceSection) {
    return null;
  }

  return (
    <Box as="main" mx="auto" height="100%" display="flex" flexDirection="column">
      <Box mb="32">
        <Text as="h1" fontWeight={600} fontSize="h5" mb="8">
          Understand Your Investing Behaviors
        </Text>

        <Text as="p" fontSize="h6" color="neutral.500" mb="32">
          Select a workflow to get started
        </Text>

        <Wrapper>
          {HasRtq && <RiskToleranceCard />}
          {HasBeFi20 && <BeFi20Card />}
          {HasAssetBucketing && <PLDCard />}
          {HasPulseCheck && <PulseCheckCard />}
        </Wrapper>
      </Box>
    </Box>
  );
};
